<template>
    <b-row id="TopBar">
        <b-col sm="9" class="menu-bar">
            <b-row>
                <b-col sm="2" class="offset-sm-2 pre-menu d-none d-sm-block">
                </b-col>
                <b-col sm="8">
                    <ul class="menu">
                        <li>
                            <router-link to="/">
                                Bizpro
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/web">
                                Web
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/graphic-design">
                                Graphic Design
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/hosting">
                                Hosting
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/e-learning">
                                E-Learning
                            </router-link>
                        </li>
                    </ul>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    export default {
      name: 'TopBar'
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/custom";

    .menu-bar {
        background-color: $yellow;
        min-height: 60px;
        border-radius: 0 0 1000px 1000px;
        position: relative;
        margin-bottom: 50px;

        > div,
        > div > div {
            height: 100%;
        }
    }

    .pre-menu {
        position: relative;

        &::before {
            position: absolute;
            content: '';
            background-color: $cyan;
            display: block;
            left: 0;
            top: calc(100% - 10px);
            width: 80px;
            height: 20px;
            border-radius: 100px;
        }

        &::after {
            position: absolute;
            content: '';
            display: block;
            background-color: $cyan;
            left: 30px;
            top: calc(100% - 39px);
            width: 20px;
            height: 80px;
            border-radius: 100px;
        }
    }

    ul.menu {
        list-style: none;
        display: flex;
        flex-direction: row;
        padding: 0;
        height: 100%;

        li {
            flex: 1 0 auto;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;

            a {
                text-transform: uppercase;
                font-size: 1.1rem;
                white-space: normal;
            }

            &.active {
                a {
                    font-weight: 700;
                }
            }
        }
    }

    @media (max-width: 1199px) {
        ul.menu {
            li {
                max-width: 100px;
            }
        }
    }

    @media (max-width: 959px) {
        ul.menu {
            li {
                max-width: 100px;

                a {
                    font-size: 0.85rem;
                }
            }
        }
    }

    @media (max-width: 719px) {
        ul.menu {
            li {
                max-width: 85px;
                a {
                    font-size: 0.65rem;
                }
            }
        }
    }

    @media (max-width: 575px) {
        .pre-menu {
            &::before,
            &::after {
                display: none;
            }
        }

        ul.menu {
            li {
                max-width: initial;
                a {
                    font-size: 1em;
                }
            }
        }
    }
</style>
